import { useEffect } from "react";
import ItemList from "../../../common/ItemList";
import LicensePlate from "../../../common/LicensePlate/LicensePlate";

const ViewContractsModal = ({ quotation, onClosed }) => {
  // LS-747 : même rail que GenerateContractModal — vider quotationOpened à la
  // fermeture, sinon un passage par « x contrats » laisse la modale de génération
  // montée sur un état périmé de la ligne.
  useEffect(() => {
    if (!window.$ || !onClosed) return;
    const $modal = window.$("#viewContractModal");
    $modal.on("hidden.bs.modal", onClosed);
    return () => $modal.off("hidden.bs.modal", onClosed);
  }, [onClosed]);

  return (
    <div
      className="modal fade"
      id="viewContractModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="viewContractModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document" style={{ maxWidth: "90%" }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="viewContractModalLabel">
              {quotation.contracts?.length || 0} contrat(s)
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body table-responsive">
            <ItemList
              items={quotation.contracts.map((contract, ck) => {
                const hitechContract = quotation.hitech_contracts.find(
                  (c) => c.uuid === contract,
                );
                return {
                  name: `Contrat ${ck + 1}`,
                  immat: hitechContract?.immat ? (
                    <LicensePlate value={hitechContract.immat} />
                  ) : (
                    "-"
                  ),
                  url_hitech: (
                    <a
                      target="_blank"
                      href={hitechContract?.hitech_url}
                      rel="noreferrer"
                    >
                      Voir sur Hitech
                    </a>
                  ),
                  url_flotte: hitechContract?.immat ? (
                    <a
                      target="_blank"
                      href={`/flotte?immatriculations[]=${encodeURIComponent(hitechContract.immat)}`}
                      rel="noreferrer"
                    >
                      Voir dans la flotte
                    </a>
                  ) : (
                    "-"
                  ),
                };
              })}
              fields={[
                {
                  label: "Contrats",
                  name: "name",
                },
                {
                  label: "Immatriculation",
                  name: "immat",
                },
                {
                  label: "Lien Hitech",
                  name: "url_hitech",
                },
                {
                  label: "Lien Flotte",
                  name: "url_flotte",
                },
              ]}
            />
          </div>
          <div className="modal-footer">
            <button
              id="close-client-modal"
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewContractsModal;
